const config = {
  test: {
    uri: import.meta.env.VITE_TEST_URI,
    serverUri: import.meta.env.VITE_TEST_SERVER_URI,
    graphqluri: import.meta.env.VITE_TEST_GRAPHQL_URI,
    apolloClientOpts: {
      credentials: 'include',
    },
    subscriptionEndpoint: import.meta.env.VITE_TEST_SUBSCRIPTION_ENDPOINT,
    appKey: import.meta.env.VITE_TEST_APP_KEY,
    stripeKey: import.meta.env.VITE_TEST_STRIPE_P_KEY,
    recaptchaKey: import.meta.env.VITE_TEST_RECAPTCHA_KEY,
    gaID: import.meta.env.VITE_GA_ID,
    version: import.meta.env.VITE_VERSION,
    googleMapsAPIKey: "AIzaSyDTaCYPqInId6JoWj5FfcC9nMmVkyyEbqs",
    sentryDSN: import.meta.env.VITE_SENTRY_DSN,
    amplitudeAPIKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  },
  production: {
    uri: import.meta.env.VITE_URI,
    serverUri: import.meta.env.VITE_SERVER_URI,
    graphqluri: import.meta.env.VITE_GRAPHQL_URI,
    apolloClientOpts: {
      credentials: 'same-origin',
    },
    subscriptionEndpoint: import.meta.env.VITE_SUBSCRIPTION_ENDPOINT,
    appKey: import.meta.env.VITE_APP_KEY,
    stripeKey: import.meta.env.VITE_STRIPE_P_KEY,
    recaptchaKey: import.meta.env.VITE_RECAPTCHA_KEY,
    gaID: import.meta.env.VITE_GA_ID,
    version: import.meta.env.VITE_VERSION,
    googleMapsAPIKey: "AIzaSyDTaCYPqInId6JoWj5FfcC9nMmVkyyEbqs",
    sentryDSN: import.meta.env.VITE_SENTRY_DSN,
    amplitudeAPIKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  },
};

export default config[import.meta.env.VITE_CUSTOM_NODE_ENV];
